import { render } from "./sales-dashboard.vue?vue&type=template&id=2b97285c"
import script from "./sales-dashboard.vue?vue&type=script&lang=js"
export * from "./sales-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__